import { format } from 'date-fns';

export function formatPublishDate(date: string) {
  return format(new Date(date), 'MMM dd, y');
}
